<div class="main-page">
  <div class="text-9xl font-bold flex items-center">
    <img width="100px" src="assets/logo.png" />
    GREEN<span class="inline-block bg-[var(--tui-primary)] text-white px-4"
      >LAND</span
    >
  </div>
</div>
